import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CoreService } from 'src/app/core/services/core.service';
import { ManageWorkflowService } from 'src/app/modules/manage-workflows/services/manage-workflow.service';
import { Dropdown } from '../../models/dropdown.model';
import * as _ from 'lodash';
import { AnnualReportingDetails } from '../../models/manageWorkflow.model';
import { SharedService } from '../../service/shared.service';

@Component({
  selector: 'app-workflow-filter-bar',
  templateUrl: './workflow-filter-bar.component.html',
  styleUrls: ['./workflow-filter-bar.component.scss']
})
export class WorkflowFilterBarComponent implements OnChanges {
  @Input() workflowFilterData: AnnualReportingDetails[];
  @Input() initialWorkflowResponse: AnnualReportingDetails[];
  @Input() hideSearchFilter = false;
  @Input() hideRegionFilter = false;
  @Input() hideAssetFilter = false;
  @Input() loadFilters = false;
  @Output() inputSearch = new EventEmitter();
  @Output() selectRegion = new EventEmitter();
  @Output() selectAsset = new EventEmitter();
  @Output() selectDeposit = new EventEmitter();
  @Output() clearFilterSelection = new EventEmitter();

  public accessLevelOptions: Dropdown[];
  public regionOptions: Dropdown[] = [];
  public assetOptions: Dropdown[] = [];
  public depositeOptions: Dropdown[] = [];
  public selectedRegions: number[] = [];
  public selectedAssets: number[] = [];
  public selectedDeposits: number[] = [];
  public inputSearched = '';
  public clearFilter: any;
  public clearSearch: any;
  public selectedRegionIds: string = '';
  public selectedAssetIds: string = '';
  public selectedDepositIds: string = '';

  constructor(private manageWorkflow: ManageWorkflowService, private coreService: CoreService, private filterService: SharedService) {
    this.accessLevelOptions = [];
  }

    getSelectedFilters() {
    let filters = this.filterService.getSelectedFilters();
    if (filters) {
      if (filters.selectedRegions.length > 0) {
        this.onSelectRegion(filters.selectedRegions);
      }
      if (filters.selectedAssets.length > 0) {
        this.onSelectAsset(filters.selectedAssets);
      }
      if (filters.selectedDeposits.length > 0) {
        this.onSelectDeposit(filters.selectedDeposits);
      }
      if(filters.inputSearched){
        this.onSearch(filters.inputSearched);
      }
    }
  }

  setFilters() {
    let selectedFilters = {
      selectedRegions: this.selectedRegions,
      selectedAssets: this.selectedAssets,
      selectedDeposits: this.selectedDeposits,
      inputSearched: this.inputSearched
    };

    this.filterService.setSelectedFilters(selectedFilters);

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.loadFilters && changes.loadFilters.currentValue) {
      if (this.workflowFilterData && Object.keys(this.workflowFilterData).length) {
        this.loadAllFilters(this.workflowFilterData);
        this.getSelectedFilters();
      }
    }
  }

  public loadOptions() {
    this.accessLevelOptions = [];
    for (let workflow of this.initialWorkflowResponse) {
      for (let workflowData of workflow.data) {
        if (this.accessLevelOptions.findIndex((x: Dropdown) => x.dropdownID == workflowData.regionID) === -1) {
          this.accessLevelOptions.push({
            dropdownDesc: workflowData.regionName,
            dropdownID: workflowData.regionID,
            dropdownOrder: 0,
            dropdownParentDesc: workflowData.regionName,
            dropdownParentID: workflowData.regionID,
          });
        }

        if (this.accessLevelOptions.findIndex((x: Dropdown) => x.dropdownID == workflowData.assetID) === -1) {
          this.accessLevelOptions.push({
            dropdownDesc: workflowData.assetName,
            dropdownID: workflowData.assetID,
            dropdownOrder: 0,
            dropdownParentDesc: workflowData.assetName,
            dropdownParentID: workflowData.assetID,
          });
        }

        if (this.accessLevelOptions.findIndex((x: Dropdown) => x.dropdownID == workflowData.depositID) === -1) {
          this.accessLevelOptions.push({
            dropdownDesc: workflowData.depositName,
            dropdownID: workflowData.depositID,
            dropdownOrder: 0,
            dropdownParentDesc: workflowData.depositName,
            dropdownParentID: workflowData.depositID,
          });
        }
      }
    }
  }

  public loadAllFilters(filterData): void {
    this.loadOptions();
    this.regionOptions = [];
    const regionListKeys = _.keys(filterData);
    const regions = [];
    const regionIdList = [];
    const assetIdList = [];
    for (const region of regionListKeys) {
      const regionID = region;
      const index = this.accessLevelOptions.findIndex((x: Dropdown) => x.dropdownID == regionID);
      if (index > -1) {
        regions.push(_.clone(this.accessLevelOptions[index]));
      }
    }
    this.regionOptions = regions;
    this.regionOptions.forEach(element => {
      regionIdList.push(element.dropdownID);
    });
    this.getAssetOptions(regionIdList);
    this.assetOptions.forEach(element => {
      assetIdList.push(element.dropdownID);
    });
    this.getDepositOptions(assetIdList);
  }

  public getAssetOptions(regions): void {
    this.assetOptions = [];
    let assetIDs = [];
    for (const region of regions) {
      const data = _.clone(this.workflowFilterData[region]);
      assetIDs = assetIDs.concat(data.assets);
    }
    const assets = [];
    for (const assetID of assetIDs) {
      const index = this.accessLevelOptions.findIndex((x: Dropdown) => x.dropdownID == assetID);
      if (index > -1) {
        assets.push(_.clone(this.accessLevelOptions[index]));
      }
    }
    this.assetOptions = assets;
  }

  public getDepositOptions(assets): void {
    this.depositeOptions = [];
    let depositeIDs = [];
    for (const asset of assets) {
      const index = this.initialWorkflowResponse.findIndex((x) => x.assets.indexOf(asset) > -1);
      if (index > -1) {
        depositeIDs = depositeIDs.concat(this.initialWorkflowResponse[index].deposits[asset]);
      }
    }
    const deposites = [];
    for (const depositeID of depositeIDs) {
      const index = this.accessLevelOptions.findIndex((x: Dropdown) => x.dropdownID == depositeID);
      if (index > -1) {
        deposites.push(_.clone(this.accessLevelOptions[index]));
      }
    }
    this.depositeOptions = deposites;
  }

  public onSelectRegion(regions: number[]): void {
    this.selectedRegions = regions;
    this.selectedRegionIds = regions.join(',');
    this.clearSearch = Math.floor(Math.random() * 100);
    this.inputSearched = '';
    this.selectedAssets = [];
    this.selectedDeposits = [];
    this.assetOptions = [];
    this.depositeOptions = [];
    const assetIdList = [];
    const regionIdList = [];
    if (!regions.length) {
      this.regionOptions.forEach(element => {
        regionIdList.push(element.dropdownID);
      });
      this.getAssetOptions(regionIdList);
    } else {
      this.getAssetOptions(regions);
    }
    this.assetOptions.forEach(element => {
      assetIdList.push(element.dropdownID);
    });
    this.getDepositOptions(assetIdList);
    this.selectRegion.emit(this.selectedRegions);
    this.setFilters();
  }

  public onSearch(searchText: string): void {
    this.inputSearched = searchText.trim();
    this.selectedRegions = [];
    this.selectedAssets = [];
    this.selectedDeposits = [];
    this.clearFilter = Math.floor(Math.random() * 100);
    this.loadAllFilters(this.workflowFilterData);
    this.setFilters();
    this.inputSearch.emit(this.inputSearched);
  }

  public onSelectAsset(assets: number[]): void {
    this.clearSearch = Math.floor(Math.random() * 100);
    this.selectedAssets = assets;
    this.selectedAssetIds = assets.join(',');

    this.selectedDeposits = [];
    const assetIdList = [];
    if (!assets.length) {
      this.assetOptions.forEach(element => {
        assetIdList.push(element.dropdownID);
      });
      this.getDepositOptions(assetIdList);
    } else {
      this.getDepositOptions(assets);
    }
    this.selectAsset.emit(this.selectedAssets);
    this.setFilters();
  }

  public onSelectDeposit(deposits: number[]): void {
    this.clearSearch = Math.floor(Math.random() * 100);
    this.selectedDeposits = deposits;
    this.selectedDepositIds = deposits.join(',');

    this.selectDeposit.emit(this.selectedDeposits);
    this.setFilters();
  }

  public clearAllFilters(): void {
    this.clearFilter = Math.floor(Math.random() * 100);
    this.clearSearch = this.clearFilter;
    this.inputSearched = '';
    this.selectedRegions = [];
    this.selectedAssets = [];
    this.selectedDeposits = [];
    this.selectedRegionIds = '';
    this.selectedAssetIds = '';
    this.selectedDepositIds = '';
    this.loadAllFilters(this.workflowFilterData);
    this.filterService.clearFilters();
    this.clearFilterSelection.emit();
  }

}
